<form [formGroup]="form">
  <div class="form-row">
    <label for="txtTitle">Título</label>
    <input
      type="text"
      id="txtTitle"
      class="w-full"
      pInputText
      formControlName="title"
      maxlength="255"
    />
  </div>

  <div class="form-row">
    <label for="txtUrl">URL</label>
    <input
      type="text"
      id="txtUrl"
      class="w-full"
      pInputText
      formControlName="url"
      maxlength="255"
    />
  </div>

  <div class="form-row">
    <label for="txtWidth">Ancho</label>
    <p-inputNumber inputId="txtWidth" formControlName="width"></p-inputNumber>
    <p-dropdown [options]="units" formControlName="widthUnit"></p-dropdown>
  </div>

  <div class="form-row">
    <label for="txtHeight">Alto</label>
    <p-inputNumber inputId="txtHeight" formControlName="height"></p-inputNumber>
    <p-dropdown [options]="units" formControlName="heightUnit"></p-dropdown>
  </div>
  <hr />
  <div class="form-row">
    <label>Categorías de comentario </label>

    <div class="category-list">
      <div
        *ngFor="let control of categoryControls; let i = index"
        class="category-row"
      >
        <input
          type="text"
          class="w-full"
          pInputText
          [formControl]="control"
          placeholder="Categoría"
        />
        <button
          type="button"
          pButton
          icon="pi pi-trash"
          class="p-button-text p-button-danger"
          (click)="removeCategory(i)"
        ></button>
      </div>
    </div>
    <button
      type="button"
      pButton
      label="Añadir categoría"
      icon="pi pi-plus"
      class="p-button-text p-button-danger"
      (click)="addCategory()"
    ></button>
  </div>
</form>

<div class="p-dialog-footer">
  <p-button
    label="Guardar cambios"
    (click)="saveChanges()"
    [loading]="saving"
  ></p-button>
</div>
